import { useOverlayPortalRoot } from "@/components/modal/overlay.hooks";
import { FloatingPortal } from "@floating-ui/react-dom-interactions";
import React, { useContext } from "react";
import { OverlayOwnerContext } from "@/components/modal/overlay-context";

export const OverlayPortal: React.FC<React.ComponentProps<typeof FloatingPortal>> = (props) => {
  const ownerRoot = useOverlayPortalRoot();
  const ownerId = useContext(OverlayOwnerContext);
  // Wait for registration so owned content never mounts under the inert page root.
  if (ownerId != null && ownerRoot == null) return null;
  // Content-level anchors can sit below other popups in the owner's floating host.
  return <FloatingPortal {...props} root={ownerRoot ?? props.root ?? null} />;
};
